import React from "react";
import Autosuggest from "react-autosuggest";
import { Col, ControlLabel, Button } from "react-bootstrap";

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value, records) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  return records
    .filter(
      record => record.name.toLowerCase().slice(0, inputLength) === inputValue,
    )
    .sort(function(a, b) {
      return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
    });
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

const renderSuggestion = suggestion => <div>{suggestion.name}</div>;

export default class DropDowWithSuggestions extends React.Component {
  constructor(props) {
    super(props);

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: "",
      suggestions: this.props.cities,
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value, this.props.cities),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };
  onSuggestionSelected = (event, { suggestion }) => {
    this.props.onSelectionChanged(suggestion.id);
  };

  resetAutosuggest = () => {
    this.setState({
      value: "",
    });
    this.props.onSelectionChanged();
  };

  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange,
    };
    return (
      <div>
        <Col style={{ textAlign: "right" }} sm={4}>
          <ControlLabel>{this.props.label}</ControlLabel>
        </Col>
        <Col style={{ textAlign: "right" }} sm={7}>
          <Autosuggest
            id="autosugest-item"
            disabled="true"
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
        </Col>
        <Col sm={1}>
          <Button
            className="react-reset-autosuggest pull-right btn-primary btn btn-default"
            onClick={this.resetAutosuggest}
          >
            Reset
          </Button>
        </Col>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sc/ui/components/DropDowWithSuggestions.js